var chunkMapping = {
	"0": [
		4640
	],
	"3": [
		4055,
		4345
	],
	"77": [
		5067
	],
	"159": [
		5149
	],
	"160": [
		5150
	],
	"163": [
		5153
	],
	"164": [
		5154
	],
	"165": [
		5155
	],
	"166": [
		5156
	],
	"167": [
		5157
	],
	"168": [
		5158
	],
	"169": [
		5159
	],
	"170": [
		5160
	],
	"171": [
		5161
	],
	"172": [
		5162
	],
	"173": [
		5163
	],
	"174": [
		5164
	],
	"175": [
		5165
	],
	"176": [
		5166
	],
	"177": [
		5167
	],
	"178": [
		5168
	],
	"179": [
		5169
	],
	"180": [
		5170
	],
	"181": [
		5171
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3671
	],
	"4345": [
		"default",
		"./helios-components",
		3671
	],
	"4640": [
		"default",
		"./Containers",
		3581
	],
	"5067": [
		"default",
		"./OrderlessInvoices",
		3581
	],
	"5149": [
		"default",
		"./AsyncEventTracker",
		3581
	],
	"5150": [
		"default",
		"./HostWrapper",
		3581
	],
	"5153": [
		"default",
		"./CheckoutV3",
		3581
	],
	"5154": [
		"default",
		"./CheckoutConfirmation",
		3581
	],
	"5155": [
		"default",
		"./ContactCreditCards",
		3581
	],
	"5156": [
		"default",
		"./AuditDialog",
		3581
	],
	"5157": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3581
	],
	"5158": [
		"default",
		"./InvoiceDialog",
		3581
	],
	"5159": [
		"default",
		"./PaymentDueModal",
		3581
	],
	"5160": [
		"default",
		"./PaymentModal",
		3581
	],
	"5161": [
		"default",
		"./PaymentHistory",
		3581
	],
	"5162": [
		"default",
		"./PaymentConfigurations",
		3581
	],
	"5163": [
		"default",
		"./PaymentPreferences",
		3581
	],
	"5164": [
		"default",
		"./ManagePaymentProcessing",
		3581
	],
	"5165": [
		"default",
		"./MobilePaymentsWrapper",
		3581
	],
	"5166": [
		"default",
		"./Challenge",
		3581
	],
	"5167": [
		"default",
		"./ManagePaymentMethods",
		3581
	],
	"5168": [
		"default",
		"./LightspeedReports",
		3581
	],
	"5169": [
		"default",
		"./ActivateLightspeedPayments",
		3581
	],
	"5170": [
		"default",
		"./MarketingLandingPage",
		3581
	],
	"5171": [
		"default",
		"./ShippingPromotionsListContainer",
		3581
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4345": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3671
		}
	],
	"4640": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5067": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5154": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5155": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5156": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5157": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5158": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5159": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5160": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5161": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5162": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5163": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5164": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5165": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5166": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5167": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5170": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3581
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}